import { useTranslation } from 'next-i18next';
import { useQuery } from '@apollo/client';
import { CountriesQuery, CountryType } from '@/graphql/types';
import { COUNTRIES_QUERY } from '@/graphql/queries';

export const useCountries = () => {
    const { i18n } = useTranslation(); // Translations

    const { data, loading, error } = useQuery<CountriesQuery>(COUNTRIES_QUERY, {
        variables: {
            report: true,
        },
        context: { headers: { 'X-Language': i18n.language } },
        fetchPolicy: 'cache-and-network',
    });

    return { countries: data?.countries?.objects as CountryType[], loading, error };
};
